module.exports = __webpack_public_path__ + "img/grin-wink.7a78c8dc.svg";